// extracted by mini-css-extract-plugin
export default {"container":"empty-basket-notification_container__a5342","button":"empty-basket-notification_button__29efc","title":"empty-basket-notification_title__8b2c2"};